import { render, staticRenderFns } from "./DomainShares.vue?vue&type=template&id=116fea84&"
import script from "./DomainShares.vue?vue&type=script&lang=js&"
export * from "./DomainShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports